import ProjectFavouriteButtonComponent from './project-favourite-button.component'

export default ProjectFavouriteButtonComponent
